import { useRef, type MutableRefObject } from "react";

type LatestRefs<TValues extends Record<string, unknown>> = {
  [TKey in keyof TValues]: MutableRefObject<TValues[TKey]>;
};

export function useLatestRefs<TValues extends Record<string, unknown>>(
  values: TValues,
): LatestRefs<TValues> {
  const refs = useRef<LatestRefs<TValues> | null>(null);

  if (!refs.current) {
    refs.current = Object.fromEntries(
      Object.entries(values).map(([key, value]) => [key, { current: value }]),
    ) as LatestRefs<TValues>;
  }

  for (const key of Object.keys(values) as Array<keyof TValues>) {
    refs.current[key].current = values[key];
  }

  return refs.current;
}
